import React, { useState, useEffect } from "react";
import { Box, Typography, Button, Container } from "@mui/material";
import { useNavigate } from "react-router-dom";
const OfferCard = () => {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const images = ["good.jpg", "kurtha.webp", "long.jpg", "shorts.jpg"];
  const intervalDuration = 4000;

  useEffect(() => {
    const intervalId = setInterval(() => {
      setCurrentImageIndex((prevIndex) => (prevIndex + 1) % images.length);
    }, intervalDuration);

    return () => clearInterval(intervalId);
  }, [images.length]);
const navigate =useNavigate()

  return (
    <Container>
      <Typography
        sx={{
          fontSize: "1.5rem",
          mt: 5,
          borderBottom: "4px solid black",
          borderBottomRightRadius: 20,
          width: { lg: "20%", md: "20%" },
        }}
      >
        {" "}
        Special{" "}
        <span style={{ fontSize: "2.5rem", color: "#022a6b" }}>Offer</span>
      </Typography>
      <Typography sx={{ mt: 4 }}>
        Great styles, low prices. Grab our limited offers! Elevate your look
        today!
      </Typography>
      <Box
        sx={{
          position: "relative",
          boxShadow: 4,
          borderRadius: 4,
          padding: 3,
          minHeight: 350,
          maxWidth: 1200,
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundImage: `linear-gradient(#212245b2, transparent), url("${images[currentImageIndex]}")`,
          marginTop: 5,
        
        }}
      >
        <Typography
          variant="h5"
          sx={{
            position: "absolute",
            top: "20px",
            left: "50%",
            transform: "translateX(-50%)",
            color: "#fff",
            zIndex: 1,
          }}
        >
          Special Offer
        </Typography>
        <Typography
          variant="h5"
          sx={{
            position: "absolute",
            top: { lg: "50%", md: "50%", xs: "40%" },
            left: "50%",
            transform: "translateX(-50%)",
            color: "#fff",
            zIndex: 1,
          }}
        >
          Get 20% off on selected winter collection!
        </Typography>
        <Typography
          variant="h6"
          sx={{
            position: "absolute",
            top: { lg: "60%", md: "65%", xs: "65%" },
            left: "50%",
            transform: "translateX(-50%)",
            color: "#fff",
            zIndex: 1,
          }}
        >
          Limited time offer, hurry up!
        </Typography>
        <Button
        onClick={()=>navigate("/offer")}
          varient="contained"
          sx={{
            position: "absolute",
            display: "flex",
            boxShadow: 24,
            borderRadius: 5,
            right: "20px",
            fontSize: "1rem",

            padding: "8px 20px 8px 20px",
            cursor: "pointer",
            bottom: "20px",

            bgcolor: "white",
            color: "#022a6b",

            "&:hover": {
              transform: "scale(1.05)",
              transition: "0.2s",
              bgcolor: "#022a6b",
              color: "white",
            },
          }}
        >
          Shop Now
        </Button>
      </Box>
    </Container>
  );
};

export default OfferCard;
